import React from "react";
import "./QuoteSummaryCard.css";

export const parseQuoteSummaryMessage = (msg) => {
  if (!msg?.message) return null;
  try {
    const parsed = typeof msg.message === "string" ? JSON.parse(msg.message) : msg.message;
    if (!parsed || typeof parsed !== "object") return null;
    return parsed;
  } catch {
    return null;
  }
};

export const parseLegacyQuoteSummaryText = (message) => {
  if (!message || typeof message !== "string") return null;
  if (!message.includes("Requested Quote Summary")) return null;

  const formData = {};
  const conversationAnswers = [];
  const formKeyMap = {
    Name: "name",
    Budget: "budget",
    Date: "date",
    City: "city",
    Coverage: "coverage",
    Editing: "editing",
  };

  const body = message.replace(/^Requested Quote Summary:\s*/i, "").trim();
  const parts = body.includes("\n")
    ? body.split("\n").map((line) => line.trim()).filter(Boolean)
    : body.split(/\s+-\s+/).map((part) => part.trim()).filter(Boolean);

  parts.forEach((part) => {
    const normalized = part.startsWith("-") ? part.slice(1).trim() : part;
    const match = normalized.match(/^([^:]+):\s*(.+)$/);
    if (!match) return;
    const label = match[1].trim();
    const value = match[2].trim();
    const mapped = formKeyMap[label];
    if (mapped) formData[mapped] = value;
    else conversationAnswers.push({ label, value });
  });

  if (!Object.keys(formData).length && !conversationAnswers.length) return null;

  return {
    title: "Shared with our team",
    formData,
    conversationAnswers,
  };
};

export const getQuoteSummaryDataFromMessage = (msg) => {
  if (!msg) return null;
  if (msg.messageType === "quoteSummary") {
    return parseQuoteSummaryMessage(msg);
  }
  if (msg.messageType === "text") {
    return parseLegacyQuoteSummaryText(msg.message);
  }
  return null;
};

const QuoteSummaryCard = ({ data, compact = false }) => {
  if (!data) return null;

  const { title = "Shared with our team", formData = {}, conversationAnswers = [] } = data;

  const formRows = [
    { label: "Name", value: formData.name },
    { label: "Budget", value: formData.budget },
    { label: "Date", value: formData.date },
    { label: "City", value: formData.city },
    { label: "Coverage", value: formData.coverage },
    { label: "Editing", value: formData.editing },
  ].filter((row) => row.value);

  return (
    <div className={`quote-summary-card ${compact ? "compact" : ""}`}>
      <div className="quote-summary-title">{title}</div>

      {formRows.map((row) => (
        <div key={row.label} className="quote-summary-row">
          <span className="quote-summary-label">{row.label}</span>
          <span className="quote-summary-val">{row.value}</span>
        </div>
      ))}

      {conversationAnswers.map((item) => (
        <div key={item.label} className="quote-summary-row">
          <span className="quote-summary-label">{item.label}</span>
          <span className="quote-summary-val">{item.value}</span>
        </div>
      ))}

      <div className="quote-summary-note">
        Our team will review everything and reach out within 2 hours with your personalised quote.
      </div>
    </div>
  );
};

export default QuoteSummaryCard;
